import React from 'react';
import type { ButtonBaseProps } from '@mui/material/ButtonBase';
import ButtonBase from '@mui/material/ButtonBase';
import type { TypographyProps } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';
import CaretLeftIcon from './vectors/CaretLeftIcon';
import Skeleton from '@mui/material/Skeleton';

interface Props {
  onClick: () => void;
  title?: React.ReactNode;
  rootProps?: ButtonBaseProps;
  titleProps?: TypographyProps;
  size?: 'medium' | 'large';
  isLoading?: boolean;
}

const sizeMap: Record<
  Required<Props>['size'],
  { iconSize: string; variant: TypographyProps['variant'] }
> = {
  medium: {
    iconSize: '24px',
    variant: 'body2',
  },
  large: {
    iconSize: '28px',
    variant: 'h3',
  },
};

export default function BackButtonWithTitle(props: Props) {
  const { title, onClick, rootProps, titleProps, size = 'medium', isLoading } = props;

  const sizeObj = sizeMap[size];

  return (
    <ButtonBase onClick={onClick} {...rootProps}>
      <CaretLeftIcon color="secondary" sx={{ fontSize: sizeObj.iconSize }} />
      <Typography ml="2px" fontWeight="semibold" variant={sizeObj.variant} noWrap {...titleProps}>
        {isLoading ? <Skeleton variant="text" width={150} /> : title}
      </Typography>
    </ButtonBase>
  );
}
